import { render, staticRenderFns } from "./games-list.vue?vue&type=template&id=189e257a"
import script from "./games-list.vue?vue&type=script&lang=js"
export * from "./games-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/games-list/games-list.vue
// module id = BXbZ
// module chunks = 0